<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <b-row v-if="images">
      <b-col cols="12" md="4">
        <b-card class="">
          <h4>آیکون لایوها</h4>

          <b-row>
            <b-media class="my-2 col-12">
              <template>
                <b-avatar
                    class="cursor-pointer"
                    ref="previewEl"
                    :src="base64ImageSrc1"
                    size="100px"
                    rounded
                    @click.native="$refs.refInputEl1.click()"
                >
                </b-avatar>
              </template>
            </b-media>

          </b-row>

          <b-button
              variant="warning"
              @click="$refs.refInputEl1.click()"
              class="mt-2 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-4"
          >
            <input
                ref="refInputEl1"
                type="file"
                class="d-none"
                @input="makeBase64Pic($event,'base64ImageSrc1')"
            >
            <span class="d-none d-sm-inline">ویرایش</span>
            <feather-icon
                icon="EditIcon"
                class="d-inline d-sm-none"
            />
          </b-button>

          <b-button
              variant="primary"
              class="mt-2 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-4"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="setPic(1)"
          >
            ثبت
          </b-button>

        </b-card>
      </b-col>

      <b-col cols="12" md="4">
        <b-card class="">
          <h4>آیکون استوری‌ها</h4>

          <b-row>
            <b-media class="my-2 col-12">
              <template>
                <b-avatar
                    class="cursor-pointer"
                    ref="previewEl"
                    :src="base64ImageSrc2"
                    size="100px"
                    rounded
                    @click.native="$refs.refInputEl2.click()"
                >
                </b-avatar>
              </template>
            </b-media>

          </b-row>

          <b-button
              variant="warning"
              @click="$refs.refInputEl2.click()"
              class="mt-2 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-4"
          >
            <input
                ref="refInputEl2"
                type="file"
                class="d-none"
                @input="makeBase64Pic($event,'base64ImageSrc2')"
            >
            <span class="d-none d-sm-inline">ویرایش</span>
            <feather-icon
                icon="EditIcon"
                class="d-inline d-sm-none"
            />
          </b-button>

          <b-button
              variant="primary"
              class="mt-2 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-4"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="setPic(2)"
          >
            ثبت
          </b-button>

        </b-card>
      </b-col>

      <b-col cols="12" md="4">
        <b-card class="">
          <h4>آیکون رادیو</h4>

          <b-row>
            <b-media class="my-2 col-12">
              <template>
                <b-avatar
                    class="cursor-pointer"
                    ref="previewEl"
                    :src="base64ImageSrc5"
                    size="100px"
                    rounded
                    @click.native="$refs.refInputEl5.click()"
                >
                </b-avatar>
              </template>
            </b-media>

          </b-row>

          <b-button
              variant="warning"
              @click="$refs.refInputEl5.click()"
              class="mt-2 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-4"
          >
            <input
                ref="refInputEl5"
                type="file"
                class="d-none"
                @input="makeBase64Pic($event,'base64ImageSrc5')"
            >
            <span class="d-none d-sm-inline">ویرایش</span>
            <feather-icon
                icon="EditIcon"
                class="d-inline d-sm-none"
            />
          </b-button>

          <b-button
              variant="primary"
              class="mt-2 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-4"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="setPic(5)"
          >
            ثبت
          </b-button>

        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">

        <b-card >
          <b-row class="px-2">

            <h3 class="mb-2">ویدیو بخش معرفی استاد</h3>

            <video
                v-if="base64Video"
                class="col-12"
                controls
                style="max-height: 30rem;"
            >
              <source
                  size=""
                  :src="base64Video"
                  type=""
              />
            </video>

<!--            <b-button-->
<!--                variant="danger"-->
<!--                class="mt-2 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"-->
<!--                :block="$store.getters['app/currentBreakPoint'] === 'xs'"-->
<!--                @click="deleteTrailer"-->
<!--            >-->
<!--              <span class="">حذف تریلر</span>-->
<!--            </b-button>-->

          </b-row>

          <b-form>
            <b-row>

              <!-- Field: fileData -->
              <b-col
                  cols="12"
                  md="4"
              >
                <b-button
                    class="mt-2 col-12"
                    variant="warning"
                    @click="$refs.refInputEl3.click()"
                >
                  <input
                      ref="refInputEl3"
                      type="file"
                      class="d-none"
                      @change="makeBase64Video($event)"
                  >
                  <span class="">بارگذاری ویدیو جدید</span>
                </b-button>
              </b-col>

              <b-col
                  cols="12"
                  md="4"
              >

                <b-button
                    variant="primary"
                    class="mt-2 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
                    :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                    @click="uploadVideo"
                >
                  <span class="">ثبت</span>
                </b-button>

              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

<!--    <b-row v-if="images">-->
<!--      <b-col cols="12">-->
<!--        <b-card class="">-->
<!--          <h4>بنر های آموزش 5 ستاره</h4>-->

<!--          <b-row>-->
<!--            <b-media class="my-2 col-4">-->
<!--              <template>-->
<!--                <b-avatar-->
<!--                    class="cursor-pointer w-100"-->
<!--                    ref="previewEl"-->
<!--                    :src="base64ImageSrc5"-->
<!--                    size="300px"-->
<!--                    rounded-->
<!--                    @click.native="$refs.refInputEl5.click()"-->
<!--                >-->
<!--                </b-avatar>-->
<!--              </template>-->
<!--              <b-button-->
<!--                  variant="warning"-->
<!--                  @click="$refs.refInputEl5.click()"-->
<!--                  class="mt-2 mb-sm-0 mr-2 col-12 col-md-5"-->
<!--              >-->
<!--                <input-->
<!--                    ref="refInputEl5"-->
<!--                    type="file"-->
<!--                    class="d-none"-->
<!--                    @input="makeBase64Pic($event,'base64ImageSrc5')"-->
<!--                >-->
<!--                <span class="d-none d-sm-inline">ویرایش</span>-->
<!--                <feather-icon-->
<!--                    icon="EditIcon"-->
<!--                    class="d-inline d-sm-none"-->
<!--                />-->
<!--              </b-button>-->
<!--              <b-button-->
<!--                  variant="primary"-->
<!--                  class="mt-2 mb-sm-0 mr-0 col-12 col-md-5"-->
<!--                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"-->
<!--                  @click="setPic(5)"-->
<!--              >-->
<!--                ثبت-->
<!--              </b-button>-->
<!--            </b-media>-->

<!--            <b-media class="my-2 col-4">-->
<!--              <template>-->
<!--                <b-avatar-->
<!--                    class="cursor-pointer w-100"-->
<!--                    ref="previewEl"-->
<!--                    :src="base64ImageSrc6"-->
<!--                    size="300px"-->
<!--                    rounded-->
<!--                    @click.native="$refs.refInputEl6.click()"-->
<!--                >-->
<!--                </b-avatar>-->
<!--              </template>-->
<!--              <b-button-->
<!--                  variant="warning"-->
<!--                  @click="$refs.refInputEl6.click()"-->
<!--                  class="mt-2 mb-sm-0 mr-2 col-12 col-md-5"-->
<!--              >-->
<!--                <input-->
<!--                    ref="refInputEl6"-->
<!--                    type="file"-->
<!--                    class="d-none"-->
<!--                    @input="makeBase64Pic($event,'base64ImageSrc6')"-->
<!--                >-->
<!--                <span class="d-none d-sm-inline">ویرایش</span>-->
<!--                <feather-icon-->
<!--                    icon="EditIcon"-->
<!--                    class="d-inline d-sm-none"-->
<!--                />-->
<!--              </b-button>-->
<!--              <b-button-->
<!--                  variant="primary"-->
<!--                  class="mt-2 mb-sm-0 mr-0 col-12 col-md-5"-->
<!--                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"-->
<!--                  @click="setPic(6)"-->
<!--              >-->
<!--                ثبت-->
<!--              </b-button>-->
<!--            </b-media>-->

<!--            <b-media class="my-2 col-4">-->
<!--              <template>-->
<!--                <b-avatar-->
<!--                    class="cursor-pointer w-100"-->
<!--                    ref="previewEl"-->
<!--                    :src="base64ImageSrc7"-->
<!--                    size="300px"-->
<!--                    rounded-->
<!--                    @click.native="$refs.refInputEl7.click()"-->
<!--                >-->
<!--                </b-avatar>-->
<!--              </template>-->
<!--              <b-button-->
<!--                  variant="warning"-->
<!--                  @click="$refs.refInputEl7.click()"-->
<!--                  class="mt-2 mb-sm-0 mr-2 col-12 col-md-5"-->
<!--              >-->
<!--                <input-->
<!--                    ref="refInputEl7"-->
<!--                    type="file"-->
<!--                    class="d-none"-->
<!--                    @input="makeBase64Pic($event,'base64ImageSrc7')"-->
<!--                >-->
<!--                <span class="d-none d-sm-inline">ویرایش</span>-->
<!--                <feather-icon-->
<!--                    icon="EditIcon"-->
<!--                    class="d-inline d-sm-none"-->
<!--                />-->
<!--              </b-button>-->
<!--              <b-button-->
<!--                  variant="primary"-->
<!--                  class="mt-2 mb-sm-0 mr-0 col-12 col-md-5"-->
<!--                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"-->
<!--                  @click="setPic(7)"-->
<!--              >-->
<!--                ثبت-->
<!--              </b-button>-->
<!--            </b-media>-->
<!--          </b-row>-->
<!--        </b-card>-->
<!--      </b-col>-->
<!--    </b-row>-->

    <b-row>
      <b-col cols="12">
        <b-card v-for="item in pageData">

          <b-form-group
              :label="item.title"
              label-for="blog-content"
              class="mb-2"
          >
            <b-form-textarea
                id="blog-content"
                rows="4"
                v-model="item.content"
            ></b-form-textarea>
          </b-form-group>

          <!-- Action Buttons -->
          <b-button
              variant="primary"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="updateSection(item)"
          >
            ثبت
          </b-button>

        </b-card>
      </b-col>
    </b-row>

  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormTextarea,
  BMedia,
  BAvatar,
  BOverlay, BForm,
} from 'bootstrap-vue'
import NewCategoryProperty from "@/views/apps/e-commerce/e-commerce-add/NewCategoryProperty";
import vSelect from "vue-select";
import {StorySetStoryRequest} from "@/libs/Api/Story";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {AccountGetSliderRequest, AccountSetSliderRequest} from "@/libs/Api/Account";
import {StaticPageGetByTypeRequest, StaticPageUpdateRequest} from "@/libs/Api/StaticPage";
import Helper from "@/libs/Helper";

export default {
  title: "ویرایش صفحه اصلی - پنل ادمین لنزآوا",
  name: "Home",
  data() {
    return {
      pageData:null,
      overlay: false,
      images: null,
      base64ImageSrc1: null,
      base64ImageSrc2: null,
      base64ImageSrc5: null,
      base64ImageSrc6: null,
      base64ImageSrc7: null,
      base64Video:null,
      video:null,
      pic1: null,
      pic2: null,
      pic5: null,
      pic6: null,
      pic7: null,
    }
  },
  async created() {
    await this.getPics();
    await this.getData();
  },
  methods: {
    async getData(){
      let _this = this;
      _this.showLoading = true;

      let type = 3;

      let staticPageGetByTypeRequest = new StaticPageGetByTypeRequest(_this);
      staticPageGetByTypeRequest.setType(type);
      await staticPageGetByTypeRequest.fetch(function (content){
        _this.showLoading = false;
        _this.pageData = content;
      },function (error){
        _this.showLoading = false;
        console.log(error)
      })
    },
    async getPics() {
      let _this = this;

      let accountGetSliderRequest = new AccountGetSliderRequest(_this)
      await accountGetSliderRequest.fetch(function (content) {
        _this.images = content;
        content.forEach(item => {
          if (item.priority === 1) {
            _this.base64ImageSrc1 = Helper.baseUrl+'media/gallery/slider/'+item.pictureUrl
          } else if (item.priority === 2) {
            _this.base64ImageSrc2 = Helper.baseUrl+'media/gallery/slider/'+item.pictureUrl
          } else if (item.priority === 5) {
            _this.base64ImageSrc5 = Helper.baseUrl+'media/gallery/slider/'+item.pictureUrl
          }else if (item.priority === 6) {
            _this.base64ImageSrc6 = Helper.baseUrl+'media/gallery/slider/'+item.pictureUrl
          }else if (item.priority === 7) {
            _this.base64ImageSrc7 = Helper.baseUrl+'media/gallery/slider/'+item.pictureUrl
          }else if (item.priority === 8) {
            _this.base64Video = Helper.baseUrl+'media/gallery/slider/'+item.pictureUrl
          }
        })
      }, function (error) {})
    },
    async readAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onerror = reject;
        fr.onload = () => {
          resolve(fr.result.split(",")[1]);
        }
        fr.readAsDataURL(file);
      });
    },
    async makeBase64Pic(e, index) {
      const _this = this;
      _this.overlay = true;
      let file = e.target.files[0];
      _this[index] = URL.createObjectURL(file);
      const result = await _this.readAsDataURL(file);
      if (index === "base64ImageSrc1"){
        _this.pic1 = result;
      }else if (index === "base64ImageSrc2") {
        _this.pic2 = result;
      }else if (index === "base64ImageSrc5") {
        _this.pic5 = result;
      }else if (index === "base64ImageSrc6") {
        _this.pic6 = result;
      }else if (index === "base64ImageSrc7") {
        _this.pic7 = result;
      }
      _this.overlay = false;
    },
    async setPic(param) {
      let _this = this;
      _this.overlay = true;
      let data = null
      if (param === 1) {
        data = {
          base64: _this.pic1,
          priority: 1
        }
      } else if (param === 2) {
        data = {
          base64: _this.pic2,
          priority: 2
        }
      } else if (param === 5) {
        data = {
          base64: _this.pic5,
          priority: 5
        }
      } else if (param === 6) {
        data = {
          base64: _this.pic6,
          priority: 6
        }
      } else if (param === 7) {
        data = {
          base64: _this.pic7,
          priority: 7
        }
      }

      let accountSetSliderRequest = new AccountSetSliderRequest(_this);
      accountSetSliderRequest.setParams(data);
      await accountSetSliderRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        console.log(error)
      })
    },
    async makeBase64Video(e) {
      const _this = this;
      let file = e.target.files[0];
      _this.base64Video = URL.createObjectURL(file);
      _this.video = await _this.readAsDataURL(file);
    },
    async uploadVideo() {
      let _this = this;
      _this.overlay = true;

      let  data = {
        base64: _this.video,
        priority: 8
      }

      let accountSetSliderRequest = new AccountSetSliderRequest(_this);
      accountSetSliderRequest.setParams(data);
      await accountSetSliderRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        console.log(error)
      })
    },
    async updateSection(param){
      let _this = this;

      _this.showLoading=true;

      let staticPageUpdateRequest = new StaticPageUpdateRequest(_this);
      staticPageUpdateRequest.setParams(param);
      await staticPageUpdateRequest.fetch(function (content){
        _this.showLoading=false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        _this.getData();
      },function (error){
        _this.showLoading=false;
        console.log(error)
      })
    },
    deletePic() {
      this.storyData.base64 = null;
      this.base64ImageSrc = null;
    },
  },
  components: {
    BForm,
    NewCategoryProperty,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    vSelect,
  },
}
</script>

<style scoped>

</style>
